export default __webpack_public_path__ + "static/wellsfargo-a8779c9a18cad2f33e796b90dd8075c2.png";